import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=bb834e94&scoped=true&"
import script from "./TreeNode.vue?vue&type=script&lang=js&"
export * from "./TreeNode.vue?vue&type=script&lang=js&"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=bb834e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb834e94",
  null
  
)

export default component.exports